import { MonthlyCharge, PricingMonthlyRow } from './api';

/** Selection order does not change an agreement. Validate before persisting. */
export const canonicalMonthlyCaseNames = (names: string[]): string[] => names.map(name => name.trim()).sort();

export function monthlyCaseScopeIssue(value: unknown, availableCaseNames?: readonly string[]): string | null {
  if (value === undefined) return null;
  if (!Array.isArray(value) || value.some(name => typeof name !== 'string' || !name.trim() || name.trim().length > 200)) {
    return 'Choose valid case names for this service.';
  }
  const names = canonicalMonthlyCaseNames(value);
  if (new Set(names).size !== names.length) return 'Choose each case only once.';
  if (availableCaseNames && names.some(name => !availableCaseNames.some(available => available.trim() === name))) {
    return 'Review cases that are no longer in this estimate.';
  }
  return null;
}

/** Appended only for explicit scope so old approval snapshots remain identical. */
export function monthlyCaseScopeBasis(names: string[] | undefined): ['case-scope-v1', string[]] | undefined {
  return names === undefined ? undefined : ['case-scope-v1', canonicalMonthlyCaseNames(names)];
}

export function effectiveMonthlyCaseNames(row: PricingMonthlyRow, charge?: MonthlyCharge): string[] | undefined {
  if (charge?.caseNames !== undefined) return canonicalMonthlyCaseNames(charge.caseNames);
  if (row.caseNames !== undefined) return canonicalMonthlyCaseNames(row.caseNames);
  return row.case?.trim() ? [row.case.trim()] : undefined;
}

export function monthlyCaseScopeLabel(names: string[] | undefined): string {
  return names?.length ? `Cases: ${canonicalMonthlyCaseNames(names).join(', ')}` : '';
}
